<div class="content content--{{ size }}">
  @if (plusTop) {
    <app-icon class="content__plus content__plus--{{ plusTop }}" [icon]="'plus'" [width]="24"></app-icon>
  }
  <div class="content__main content__main--gap-{{ gap }}">
    <ng-content></ng-content>
  </div>
  @if (plusBottom) {
    <app-icon class="content__plus content__plus--{{ plusBottom }}" [icon]="'plus'" [width]="24"></app-icon>
  }
</div>
